var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:[
    ("cv-dropdown-item " + _vm.carbonPrefix + "--dropdown-item"),
    ( _obj = {}, _obj[(_vm.carbonPrefix + "--dropdown--selected")] = _vm.internalSelected, _obj ) ],attrs:{"data-option":"","data-value":_vm.value}},[_c('a',{ref:"link",class:(_vm.carbonPrefix + "--dropdown-link"),attrs:{"aria-checked":_vm.internalSelected,"href":"javascript:void(0)","role":"menuitemradio","tabindex":"-1"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }